module.exports = global["ColorThief"] = require("-!./color-thief.min.js");